import styled from 'styled-components';
import Heading from '../Heading';
const H4 = styled(Heading).withConfig({
  displayName: "H4",
  componentId: "sc-16rndgn-0"
})([""]);
H4.propTypes = Heading.propTypes;

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
H4.defaultProps = Object.assign({}, Heading.defaultProps, {
  tagName: 'h4'
});
H4.displayName = 'H4';
export default H4;